import AT from '../constants/action-types';

const initialState = {
  error: null,
  initializing: true
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function app(state = initialState, action: any = {}) {
  switch (action.type) {
    case AT.APP_INIT_COMPLETED:
      return { ...state, initializing: false };
    case AT.APP_INIT_RESET:
      return { ...state, initializing: true };
    default:
      return state;
  }
}
